/**
 * Source unique des dynamic imports pour React.lazy (routes.jsx).
 * Ne pas appeler ces loaders en dehors de lazyWithRetry — le prefetch JS au hover
 * provoque des Invalid hook call (React Compiler + double graphe de modules en dev).
 * Prefetch au hover : données API uniquement (prefetchSidebarRoute.ts).
 */

export type RouteModuleLoader = () => Promise<{ default: unknown }>

export const loadApp = () => import('../App')
export const loadLogin = () => import('../pages/auth/Login')
export const loadSignOn = () => import('../pages/auth/SignOn')
export const loadResetPassword = () => import('../pages/auth/ResetPassword')
export const loadAcceptFreelanceInvitation = () => import('../pages/auth/AcceptFreelanceInvitation')
export const loadHandbook = () => import('../pages/Handbook')
export const loadDevicesTools = () => import('../pages/DevicesTools')
export const loadFaq = () => import('../pages/Faq')
export const loadFiles = () => import('../pages/Files')
export const loadClients = () => import('../pages/Clients')
export const loadClientsLayout = () => import('../pages/Clients/ClientsLayout')
export const loadClientDetail = () => import('../pages/Clients/ClientDetail')
export const loadFreelancersLayout = () => import('../pages/Freelancers/FreelancersLayout')
export const loadFreelancers = () => import('../pages/Freelancers')
export const loadFreelancerDetail = () => import('../pages/Freelancers/FreelancerDetail')
export const loadMissionsLayout = () => import('../pages/Missions/MissionsLayout')
export const loadMissions = () => import('../pages/Missions')
export const loadMissionCreate = () => import('../pages/Missions/Create')
export const loadMissionEdit = () => import('../pages/Missions/Edit')
export const loadUsersLayout = () => import('../components/settings/users/UsersLayout')
export const loadUsers = () => import('../components/settings/users/Users')
export const loadTagManagement = () => import('../components/settings/users/TagManagement')
export const loadActivityReportSummary = () => import('../pages/Reporting/ActivityReportSummary')
export const loadAudit = () => import('../pages/Audit')
export const loadActivityReportLayout = () => import('../pages/ActivityReport/ActivityReportLayout')
export const loadActivityReport = () => import('../pages/ActivityReport')
export const loadActivityReportCreate = () => import('../pages/ActivityReport/Create')
export const loadActivityReportView = () => import('../pages/ActivityReport/View')
export const loadActivityReportInvoicePreview = () =>
  import('../pages/ActivityReport/Preview/InvoicePreview')
export const loadAvailability = () => import('../pages/Availability')
export const loadOurPartners = () => import('../pages/OurPartners')
export const loadAccounting = () => import('../pages/Accounting')
export const loadVerify = () => import('../pages/Onboarding/Verify/Verify.jsx')
export const loadFreelancerOnboarding = () =>
  import('../pages/Onboarding/FreelancerOnboarding/FreelancerOnboardingPage')
export const loadCompanyOnboarding = () => import('../pages/CompanyOnboarding/index.jsx')
export const loadSettings = () => import('../pages/Settings')
export const loadBillingSuccess = () => import('../pages/Billing/Success')
export const loadBillingCancel = () => import('../pages/Billing/Cancel')
export const loadAuthCallback = () => import('../pages/auth/Callback')
export const loadSuperAdmin = () => import('../pages/SuperAdmin')
export const loadSuperAdminKYCDocuments = () => import('../pages/SuperAdmin/KYCDocuments')
export const loadSuperAdminTemplates = () => import('../pages/SuperAdmin/Templates')
export const loadSuperAdminBlog = () => import('../pages/SuperAdmin/Blog')
export const loadSuperAdminBlogPostForm = () => import('../pages/SuperAdmin/BlogPostForm')
export const loadSuperAdminStaffedFree = () => import('../pages/SuperAdmin/StaffedFree')
export const loadSuperAdminEInvoicing = () => import('../pages/SuperAdmin/EInvoicing')
export const loadSuperAdminEmails = () => import('../pages/SuperAdmin/Emails')
export const loadTemplateEditPage = () => import('../pages/Templates/TemplateEditPage')
export const loadActivityReportClientValidation = () =>
  import('../pages/ActivityReport/ClientValidation')
export const loadAvailabilityRespond = () => import('../pages/Availability/Respond')
export const loadPortageQuestionnaire = () => import('../pages/Portage/Questionnaire')
export const loadPortageMission = () => import('../pages/Portage/Mission')
export const loadClientContract = () => import('../pages/Client/Contract')
export const loadClientDashboard = () => import('../pages/Client/Dashboard')
export const loadNotFound = () => import('../pages/NotFound')
